exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyright[data-v-6ae0e24a]{font-size:.65rem;color:#999;text-align:center;padding:.8rem 0}", ""]);

// exports
